import { render, staticRenderFns } from "./customDesignReport.vue?vue&type=template&id=5b711b7e"
import script from "./customDesignReport.vue?vue&type=script&lang=js"
export * from "./customDesignReport.vue?vue&type=script&lang=js"
import style0 from "./customDesignReport.vue?vue&type=style&index=0&id=5b711b7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports